<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="新增会议"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="addForm"
                :rules="rules"
                :model="addForm"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="会议时间" size="small" prop="date">
                            <el-date-picker
                                v-model="addForm.date"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                :picker-options="pickerOptions"
                                @change="dateChange"
                            >
                            </el-date-picker>
                        </el-form-item>
                        
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="会议地址"
                            size="small"
                            style="text-align: left"
                            :rules="{
                                required: true,
                                message: '请选择会议地点',
                                trigger: 'change',
                            }"
                        >
                            <el-radio-group
                                v-model="addressType"
                                size="mini"
                                @change="addressTypeChange"
                            >
                                <el-radio :label="1">公司会议室</el-radio>
                                <el-radio :label="2">自定义地点</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>
                            <el-row>
                                <el-col :span="24" v-show="addressType == 1">
                                    <el-form-item
                                        size="small"
                                        prop="room_id"
                                        label-width="0"
                                        style="margin-bottom: 0 !important"
                                        :error="roomError"
                                        :rules="{
                                            required: addressType == 1,
                                            message: '请选择公司会议室',
                                            trigger: 'change',
                                        }"
                                    >
                                        <el-select
                                            v-model="addForm.room_id"
                                            clearable
                                            filterable
                                            placeholder="请选择公司会议室"
                                            size="small"
                                            @change="roomChange"
                                        >
                                            <el-option
                                                v-for="item in meetingSelect"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24" v-show="addressType == 2">
                                    <el-form-item
                                        size="small"
                                        prop="address"
                                        label-width="0"
                                        style="margin-bottom: 0 !important"
                                        :rules="{
                                            required: addressType == 2,
                                            message: '请输入自定义地点',
                                            trigger: 'blur',
                                        }"
                                    >
                                        <el-input
                                            v-model="addForm.address"
                                            clearable
                                            placeholder="请输入自定义地点"
                                            size="small"
                                        >
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item>
                            <el-row
                                :gutter="10"
                                type="flex"
                                justify="end"
                                v-show="addressType == 1"
                            >
                                <el-col :span="12"
                                    ><el-form-item
                                        size="small"
                                        prop="meeting_start_time"
                                        label-width="0"
                                        style="margin-bottom: 0 !important"
                                    >
                                        <el-time-select
                                            v-model="addForm.meeting_start_time"
                                            placeholder="起始时间"
                                            :loading="startTimeSelectLoading"
                                            filterable
                                            @visible-change="
                                                startTimeVisibleChange
                                            "
                                            @change="
                                                addForm.meeting_end_time = ''
                                            "
                                        >
                                            <el-option
                                                v-for="item in startTimeSelect"
                                                :key="item.date"
                                                :label="
                                                    item.date +
                                                    ' ' +
                                                    item.desc +
                                                    ' ' +
                                                    item.user_name
                                                "
                                                :value="item.date"
                                                :disabled="
                                                    item.desc == '已过期' ||
                                                    item.desc == '已预约'
                                                "
                                            >
                                            </el-option>
                                        </el-time-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item
                                        size="small"
                                        prop="meeting_end_time"
                                        label-width="0"
                                        style="margin-bottom: 0 !important"
                                    >
                                        <el-time-select
                                            v-model="addForm.meeting_end_time"
                                            placeholder="结束时间"
                                            :loading="endTimeSelectLoading"
                                            filterable
                                            @visible-change="
                                                endTimeVisibleChange
                                            "
                                        >
                                            <el-option
                                                v-for="item in endTimeSelect"
                                                :key="item.date"
                                                :label="
                                                    item.date + ' ' + item.desc
                                                "
                                                :value="item.date"
                                                :disabled="item.is_use != 0"
                                            >
                                            </el-option>
                                        </el-time-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row
                                :gutter="10"
                                type="flex"
                                justify="end"
                                v-show="addressType == 2"
                            >
                                <el-col :span="12"
                                    ><el-form-item
                                        size="small"
                                        prop="meeting_start_time"
                                        label-width="0"
                                        style="margin-bottom: 0 !important"
                                    >
                                        <el-time-select
                                            placeholder="起始时间"
                                            v-model="addForm.meeting_start_time"
                                            :picker-options="start_time"
                                            @change="startTimeChange"
                                        >
                                        </el-time-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item
                                        size="small"
                                        prop="meeting_end_time"
                                        label-width="0"
                                        style="margin-bottom: 0 !important"
                                    >
                                        <el-time-select
                                            placeholder="结束时间"
                                            v-model="addForm.meeting_end_time"
                                            :picker-options="end_time"
                                        >
                                        </el-time-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="参会人"
                            size="small"
                            prop="Conferee"
                        >
                            <el-select
                                v-model="addForm.Conferee"
                                clearable
                                filterable
                                multiple
                                placeholder="请选择参会人"
                                size="small"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                            <!-- <el-cascader
                                v-model="addForm.Conferee"
                                :options="departUserList"
                                :props="props"
                                clearable
                                filterable
                                @change="changeCascader"
                                placeholder="请选择参会人"
                                >
                            </el-cascader> -->
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="会议主题"
                            size="small"
                            prop="title"
                        >
                            <el-input
                                clearable
                                placeholder="请输入会议主题"
                                maxlength="30"
                                size="small"
                                v-model="addForm.title"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="会议内容"
                            size="small"
                            prop="content"
                        >
                            <!-- <vue-tinymce
                                v-if="addVisible"
                                v-model="addForm.content"
                                :setting="setting"
                                :setup="setup"
                            /> -->
                            <el-input
                                type="textarea"
                                placeholder="会议内容"
                                size="small"
                                v-model="addForm.content"
                                :autosize="{ minRows: 20, maxRows: 40 }"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="addVisible = false">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import * as publicApi from "@/http/publicApi.js";
import * as api from "@/http/api.js";
import { mapState, mapActions } from "vuex";
export default {
    data() {
        return {
            addForm: {
                Conferee: [],
                conferee: "",
                address: "",
                title: "",
                meeting_start: "",
                meeting_end: "",
                meeting_start_time: "",
                meeting_end_time: "",
                content: "",
                date: "",
                room_id: "",
            },
            rules: {
                Conferee: [
                    {
                        required: true,
                        message: "请选择参会人",
                        trigger: "change",
                    },
                ],
                title: [
                    {
                        required: true,
                        message: "请输入会议主题",
                        trigger: "blur",
                    },
                ],
                date: [
                    {
                        required: true,
                        message: "请选择会议日期",
                        trigger: "change",
                    },
                ],
                meeting_start_time: [
                    {
                        required: true,
                        message: "请选择开始时间",
                        trigger: "change",
                    },
                ],
                meeting_end_time: [
                    {
                        required: true,
                        message: "请选择结束时间",
                        trigger: "change",
                    },
                ],
                content: [
                    {
                        required: true,
                        message: "请输入会议内容",
                        trigger: "blur",
                    },
                ],
            },
            props: {
                multiple: true,
                value: "id",
                label: "name",
                children: "child",
            },
            addressType: 1,
            meetingSelect: [],
            roomError: "",
            startTimeSelectLoading: false,
            startTimeSelectCache: false,
            startTimeSelect: [],
            endTimeSelectLoading: false,
            endTimeSelectCache: false,
            endTimeSelect: [],
            start_time: {
                start: "07:00",
                step: "00:15",
                end: "23:45",
            },
            end_time: {
                start: "07:00",
                step: "00:15",
                end: "23:45",
            },
        };
    },
    props: {
        addVisible: Boolean,
        tableItem: Object,
        presetValue: Object,
    },
    watch: {
        addVisible: {
            handler(newValue) {
                if (newValue) {
                    this.getStaffSelect();
                    this.meetingSelectRoom();
                    // this.getDepartUser();
                }
            },
        },
        addForm: {
            handler(newValue) {},
            deep: true,
        },
        presetValue: {
            handler(newValue) {
                if (newValue) {
                    this.addForm.room_id = newValue.room_id;
                    this.addForm.date = newValue.date;
                }
            },
        },
    },
    created() {},
    methods: {
        ...mapActions(["getStaffSelect", "getDepartUser"]),
        /**
         * 保存
         */
        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    let {
                        meeting_start_time,
                        meeting_end_time,
                        date,
                        Conferee,
                    } = this.addForm;
                    this.addForm.meeting_start = `${date} ${meeting_start_time}`;
                    this.addForm.meeting_end = `${date} ${meeting_end_time}`;
                    this.addForm.conferee = Conferee.toString();
                    oaApi
                        .meetingList({ ...this.addForm }, "post")
                        .then((res) => {
                            if (res) {
                                if (this.presetValue) {
                                    this.$parent.meetingRoom();
                                } else {
                                    this.$parent.meetingList();
                                }
                                this.closeDialog();
                                this.$message.success("新增成功!");
                            }
                        });
                }
            });
        },
        /**
         * 富文本失去焦点
         */
        setup(editor) {
            editor.on("blur", (e) => {
                this.$refs["addForm"].clearValidate("content");
            });
            editor.on("KeyDown", (e) => {
                if ((e.keyCode == 8 || e.keyCode == 46) && editor.selection) {
                    // delete & backspace keys
                    var selectedNode = editor.selection.getNode(); // get the selected node (element) in the editor
                    if (selectedNode && selectedNode.nodeName == "IMG") {
                        publicApi
                            .delFile(
                                {
                                    image_url: selectedNode.src,
                                },
                                "post"
                            )
                            .then((res) => {
                                if (res.code == 200) {
                                }
                            })
                            .catch((err) => {
                                return false;
                            });
                    }
                }
            });
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:addVisible", false);
            this.addressType = 1;
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
        },
        changeCascader(val) {
        },
        /**
         * 获取会议室下拉菜单
         */
        meetingSelectRoom() {
            oaApi.meetingSelectRoom({}, "get").then((res) => {
                if (res.code == 200) {
                    this.meetingSelect = res.data;
                }
            });
        },
        addressTypeChange(label) {
            if (label === 1) {
                this.addForm.address = "";
            } else if (label === 2) {
                this.addForm.room_id = "";
            }
            //this.$refs.addForm.resetFields();
        },
        roomChange(val) {
            if (val) {
                this.roomError = "";
                if (this.addForm.meeting_start_time)
                    this.addForm.meeting_start_time = "";
                if (this.addForm.meeting_end_time)
                    this.addForm.meeting_end_time = "";
                this.$refs.addForm.clearValidate("room_id");
            }
        },
        /**
         * 会议开始时间下拉框显示/隐藏
         */
        startTimeVisibleChange(bool) {
            if (bool) {
                // 验证有无选会议日期
                if (!this.addForm.date) {
                    this.$refs.addForm.validateField("date");
                }
                // 验证有无选会议室
                if (this.addressType == 1 && !this.addForm.room_id) {
                    this.roomError = "请选择会议室";
                }
                // 开始时间下拉框没有数据, 才发请求
                if (this.addForm.date && this.addForm.room_id) {
                    this.meetingStartAvailableTime();
                }
            }
        },
        /**
         * 获取开始时间
         */
        meetingStartAvailableTime() {
            this.startTimeSelectLoading = true;
            oaApi
                .meetingStartAvailableTime(
                    { date: this.addForm.date, room_id: this.addForm.room_id },
                    "get"
                )
                .then((res) => {
                    if (res.code == 200) {
                        this.startTimeSelectLoading = false;
                        // this.startTimeSelect = res.data;
                        this.startTimeSelect = res.data.filter((item) => {
                            return item.is_be_overdue == 0;
                        });
                    }
                });
        },
        /**
         * 会议结束时间下拉框显示/隐藏
         */
        endTimeVisibleChange(bool) {
            if (bool) {
                // 验证有无选会议日期
                if (!this.addForm.date) {
                    this.$refs.addForm.validateField("date");
                }
                // 验证有无选会议室
                if (this.addressType == 1 && !this.addForm.room_id) {
                    this.roomError = "请选择会议室";
                }
                if (!this.addForm.meeting_start_time) {
                    this.$refs.addForm.validateField("meeting_start_time");
                }
                // 结束时间下拉框没有数据, 才发请求
                if (
                    this.addForm.date &&
                    this.addForm.room_id &&
                    this.addForm.meeting_start_time
                ) {
                    this.meetingEndAvailableTime();
                }
            }
        },
        /**
         * 获取结束时间
         */
        meetingEndAvailableTime() {
            this.endTimeSelectLoading = true;
            oaApi
                .meetingEndAvailableTime(
                    {
                        date: this.addForm.date,
                        room_id: this.addForm.room_id,
                        meeting_start: this.addForm.meeting_start_time,
                    },
                    "get"
                )
                .then((res) => {
                    if (res.code == 200) {
                        this.endTimeSelectLoading = false;
                        this.endTimeSelectCache = true;
                        // this.endTimeSelect = res.data;
                        this.endTimeSelect = res.data.filter((item) => {
                            return item.is_be_overdue == 0;
                        });
                    }
                });
        },
        dateChange(val) {
            this.addForm.meeting_start_time = "";
            this.addForm.meeting_end_time = "";
            this.$refs.addForm.clearValidate("meeting_start_time");
            this.$refs.addForm.clearValidate("meeting_end_time");
            this.limitTime(val);
        },
        limitTime(time) {
            if (this.addressType == 2) {
                // 当天
                if (time.split("-")[2] == new Date().getDate()) {
                    let hours = new Date().getHours();
                    let minute = new Date().getMinutes();
                    hours < 10 ? (hours = "0" + hours) : hours;
                    if (minute > 45) {
                        this.start_time.start = `${+hours + 1}:00`;
                        this.end_time.start = `${+hours + 1}:00`;
                    } else if (minute > 30) {
                        this.start_time.start = `${hours}:45`;
                        this.end_time.start = `${+hours + 1}:00`;
                    } else if (minute > 15) {
                        this.start_time.start = `${hours}:30`;
                        this.end_time.start = `${hours}:45`;
                    } else if (minute > 1) {
                        this.start_time.start = `${hours}:15`;
                        this.end_time.start = `${hours}:30`;
                    }
                }
                // 不是当天
                else {
                    this.start_time = {
                        start: "07:00",
                        step: "00:15",
                        end: "23:45",
                    };
                    this.end_time = {
                        start: "07:00",
                        step: "00:15",
                        end: "23:45",
                    };
                }
            }
        },
        startTimeChange(val) {
            if (!val) return;
            let hours = val.split(":")[0];
            let minute = val.split(":")[1];
            this.end_time.start = `${hours}:${+minute + 15}`;
            // 小时加1
            minute == 45 && (this.end_time.start = `${+hours + 1}:00`);
            if (
                this.addForm.meeting_start_time >= this.addForm.meeting_end_time
            ) {
                this.addForm.meeting_end_time = "";
            }
        },
    },
    components: {},
    computed: {
        ...mapState({
            userInfo: (state) => state.login.userInfo, // 用户信息
            setting: (state) => state.index.setting,
            staffList: (state) => state.index.staffList,
            departUserList: (state) => state.index.departUserList,
            pickerOptions: (state) => state.index.pickerOptions,
        }),
    },
};
</script>

<style lang="scss">
.add {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor,
    .el-cascader {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
                &:not(:last-child) {
                    margin-right: 30px;
                }
            }
        }
    }
    .container {
        margin-top: 10px;
    }
}
</style>
